export const SET_CHARSETS = (state, payload) => {
  state.charsets = payload;
}
